import {
  ActionConnect,
  ActionSocial,
  ActionTheme,
  HDLogo,
  HeaderAction,
  HeaderDashboardContainer,
  HeaderDashboardWrapper,
  HeaderNavigation,
  NavigationHamburger,
  NavigationMobile,
  NavigationMobileItem,
  NavigationMobileMain,
  HiddenLgBlockSpan,
} from "./styled";
import header_logo from "../../../assets/img/logo-text.png";
import header_logo_light from "../../../assets/img/logo-text.png";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { useTonAddress, useTonConnectUI, useTonWallet } from "@tonconnect/ui-react";
import { useContext, useEffect, useRef, useState } from "react";
import iconSwap from "../../../assets/Dashboard/Header/icon-swap.svg";
import iconLauch from "../../../assets/Dashboard/Header/icon-lauch.svg";
import iconLiquidity from "../../../assets/Dashboard/Header/icon-liquidity.svg";
import iconStaking from "../../../assets/Dashboard/Header/icon-staking.svg";
import iconKibble from "../../../assets/Dashboard/Header/icon-kibble.svg";
import iconKibble_light from "../../../assets/Dashboard/Header/icon-kibble_02.svg";
import iconSwap_light from "../../../assets/Dashboard/Header/iconSwap_light.svg";
import iconLauch_light from "../../../assets/Dashboard/Header/iconLauch_light.svg";
import iconLiquidity_light from "../../../assets/Dashboard/Header/iconLiquidity_light.svg";
import iconStaking_light from "../../../assets/Dashboard/Header/iconStaking_light.svg";
import balance from "../../../assets/Dashboard/Common/balance_icon.svg";
import balance_light from "../../../assets/Dashboard/Common/balance_icon_light.svg";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  NavDropdown,
  Button,
} from "react-bootstrap";
import WalletInfo from "../Wallet";
import { useGetBalancesQuery } from "../../../store/api/dexApiSlice";
import toast from "react-hot-toast";
import { ContextProviderWrapper, ModalOverlay } from "@kibble-exchange/uikit";
import close from "../../../assets/Dashboard/Common/close.svg";
import { IconProvider } from "@ant-design/icons";

const HeaderDashboard = () => {
  const [tonConnectUI] = useTonConnectUI();
  const address = useTonAddress();
  const [openHamburger, setOpenHamburger] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [titlePage, setTitlePage] = useState("");
  const [textActive, setTextActive] = useState("");
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const wallet = useTonWallet();
  const { toggleTheme, theme, isMobile } = useContext(ContextProviderWrapper)!;
  const [expanded, setExpanded] = useState<boolean>(false);

  console.log("debug theme", theme)
  const { pathname } = useLocation();
  const { id } = useParams();

  const { data: balances }: any = useGetBalancesQuery(address, {
    pollingInterval: 1000 * 20,
    skip: !wallet,
  });

  useEffect(() => {
    if (openHamburger) {
      document.body.classList.add("hidden");
    } else {
      document.body.classList.remove("hidden");
    }
  }, [openHamburger]);

  const onpenWalletInfo = async () => {
    setOpenConfirmModal(true);
  };

  const handleSetRouteName = () => {
    const textInRoute = pathname
      .replaceAll("/", " ")
      .split(" ")
      .filter((item: any) => item !== id && item);

    const title = `${textInRoute[0] ? textInRoute[0] : ""} ${
      textInRoute[1] ? `/ ${textInRoute[1]}` : ""
    }`;

    setTextActive(textInRoute[0]);

    setTitlePage(title);
  };

  useEffect(() => {
    handleSetRouteName();
  }, [pathname]);

  // handle click outside hamburger
  const hamburgerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (hamburgerRef.current && !hamburgerRef.current.contains(event.target)) {
        setCollapse(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hamburgerRef]);

  return (
    <HeaderDashboardContainer
      style={{
        backgroundColor:
          pathname === "/" && theme === "dark"
            ? "#000"
            : pathname === "/" && theme === "light"
            ? "#0375E9"
            : "",
      }}>
        <header className="header border-bottom mb-4 mb-lg-5">
          <Navbar
            expand="lg"
            collapseOnSelect
          >
            <Container fluid className="px-auto px-xl-5">
              
              <HDLogo to="/" className="header__logo">
                <img src={theme === "light" ? header_logo_light : header_logo} alt="logo" />
              </HDLogo>
              
              {/* Navigation Links */}
              <Navbar.Collapse id="navbarDexContent">
                <div className="d-flex flex-column flex-lg-row w-100">
                  <Nav className="d-block d-lg-flex align-items-center order-2 order-lg-1 me-auto">
                    <Nav.Item>
                      <Link
                        className={`nav-link text-nowrap ${
                          pathname === "/presale" ? "active-link" : ""
                        }`}
                        to="/presale"
                        onClick={() => setExpanded(false)}
                      >
                        PRESALE
                      </Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Link
                        className={`nav-link text-nowrap ${
                          pathname === "/swap" ? "active-link" : ""
                        }`}
                        to="/swap"
                        onClick={() => setExpanded(false)}
                      >
                        TRADE
                      </Link>
                    </Nav.Item>
                    <NavDropdown
                      title={
                        <>
                          EARN{" "}
                          <i className="fa-solid fa-angle-down small ms-auto ms-lg-2" />
                        </>
                      }
                      id="collasible-nav-dropdown"
                    >
                      <NavDropdown.Item>
                        <Link
                          to="/farms"
                          onClick={() => setExpanded(false)}
                        >
                          <i className="fa-light fa-house dropdown-item-icon" />
                          <div className="ms-3">
                            Farm
                            <div className="dropdown-item__desc text-muted small">
                              Stake LP tokens to earn $Leftylears
                            </div>
                          </div>
                        </Link>
                        
                      </NavDropdown.Item>
                      <NavDropdown.Item>
                         <Link
                          to="/pools"
                          onClick={() => setExpanded(false)}
                        >
                        <i className="fa-light fa-hexagon-vertical-nft dropdown-item-icon" />
                        <div className="ms-3">
                          Staking
                          <div className="text-muted small">
                          Stake tokens to earn $Leftylears
                          </div>
                        </div>
                        </Link>
                      </NavDropdown.Item>
                      <NavDropdown.Item >
                        <Link
                          to="/liquidity"
                          onClick={() => setExpanded(false)}
                        >
                        <i className="fa-light fa-hexagon-vertical-nft dropdown-item-icon" />
                        <div className="ms-3">
                          Liquidity
                          <div className="text-muted small">
                            Add liquidity to get trade fee
                          </div>
                        </div>
                        </Link>
                      </NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Item>
                      <Link
                        className={`nav-link text-nowrap ${
                          pathname === "/win" ? "active-link" : ""
                        }`}
                        to="/win"
                        onClick={() => setExpanded(false)}
                      >
                        WIN
                      </Link>
                    </Nav.Item>
                    <Nav.Item>
                      <a
                          className={`nav-link text-nowrap ${
                            pathname === "/whitepaper" ? "active-link" : ""
                          }`}
                          href="/assets/whitepaper.pdf"
                          target="_blink"
                        >
                          Whitepaper
                      </a>                      
                    </Nav.Item>
                  </Nav>
                  <Nav className="d-block d-lg-flex align-items-center align-items-lg-center border-top-mobile order-3 ms-0 ms-lg-2">
                    <ActionConnect
                      className={theme}
                      onClick={() => {
                        !address ? tonConnectUI.openModal() : onpenWalletInfo();
                      }}>
                      {address ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "10px",
                          }}>
                          <figure>
                            <img src={theme === "light" ? balance_light : balance} alt="icon" />
                          </figure>
                          <p>
                            {address.slice(0, 4)}...{address.slice(-4)}
                          </p>
                        </div>
                      ) : (
                        <>
                          <figure>
                            <img src={theme === "light" ? balance_light : balance} alt="icon" />
                          </figure>
                          <p>
                            Connect<HiddenLgBlockSpan>&nbsp;Wallet</HiddenLgBlockSpan>
                          </p>
                        </>
                      )}
                    </ActionConnect>
                  </Nav>
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>
      </header>
      <ModalOverlay
        component={
          <WalletInfo
            address={address}
            balance={balances}
            onCloseModal={() => {
              setOpenConfirmModal(false);
            }}
          />
        }
        onClickParent={() => {
          setOpenConfirmModal(false);
        }}
        open={openConfirmModal}
        setOpen={setOpenConfirmModal}
        title={"Your wallet"}
        width="500px"
        closeIcon={close}
      />
      {/* <HeaderDashboardWrapper>
        <HDLogo to="/">
          <img src={theme === "light" ? header_logo_light : header_logo} alt="logo" />
        </HDLogo>
        <HeaderAction>
          <ActionTheme
            className={theme}
            onClick={() => {
              pathname !== "/"
                ? toggleTheme()
                : toast.error("This page doesn't support light mode");
            }}
          />
          <HeaderNavigation className={theme}>
            <p className="title-menu-item">{titlePage}</p>
            <Link to="/presale">
              <p className="top-menu-item">Presale</p>
            </Link>
            <Link to="/swap">
              <p className="top-menu-item">Trade</p>
            </Link>
            <NavigationHamburger
              ref={hamburgerRef}
              onClick={() => {
                setCollapse(!collapse);
              }}
              className={
                collapse && theme === "dark"
                  ? "open"
                  : collapse && theme === "light"
                  ? `open ${theme}`
                  : theme
              }>
              <span className="top-menu-item">&nbsp;&nbsp;Earn&nbsp;&gt;&nbsp;&nbsp;</span>
              <ul>
                {earnMenu.map((item: any, index: number) => (
                  <li
                    style={{
                      transform: collapse ? "translate(0)" : "translate(0px)",
                      opacity: collapse ? "1" : "0",
                      transition: collapse ? "all .15s linear" : "none",
                      transitionDelay: collapse ? item.delay : "unset",
                      display: item.id === 5 && !isMobile ? "none" : "block",
                    }}
                    onClick={() => {
                      setOpenHamburger(false);
                    }}
                    key={index}>
                    <NavLink to={item.href}>
                      <p style={{ marginLeft: "40px" }}>{item.title}</p>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </NavigationHamburger>
            <Link to="/play">
              <p className="top-menu-item">Win</p>
            </Link>
          </HeaderNavigation>
          <ActionSocial className={theme}>
            {socialAction.map((item, index) => {
              return (
                <li key={index}>
                  <Link to={item.href} target="_blank">
                    <img src={item.icon} alt="icon" />
                  </Link>
                </li>
              );
            })}
          </ActionSocial>
          <ActionConnect
            className={theme}
            onClick={() => {
              !address ? tonConnectUI.openModal() : onpenWalletInfo();
            }}>
            {address ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                }}>
                <figure>
                  <img src={theme === "light" ? balance_light : balance} alt="icon" />
                </figure>
                <p>
                  {address.slice(0, 4)}...{address.slice(-4)}
                </p>
              </div>
            ) : (
              <>
                <figure>
                  <img src={theme === "light" ? balance_light : balance} alt="icon" />
                </figure>
                <p>
                  Connect<HiddenLgBlockSpan>&nbsp;Wallet</HiddenLgBlockSpan>
                </p>
              </>
            )}
          </ActionConnect>
        </HeaderAction>
 */}
        <NavigationMobileMain>
          <NavigationMobile className={theme}>
            {navDataMobile.map((item: any, index: number) => {
              return (
                <Link to={item.href} key={index}>
                  <NavigationMobileItem className={theme}>
                    <div className="img-icon">
                      <figure>
                        <img
                          style={{
                            filter: `/${textActive}` === item.href ? "unset" : " contrast(0.1)",
                          }}
                          src={
                            `/${textActive}` === item.href && theme === "light"
                              ? item.light
                              : theme === "light"
                              ? item.light
                              : item.icon
                          }
                          alt={item.title}
                        />
                      </figure>
                    </div>
                    <p
                      style={{
                        color:
                          `/${textActive}` === item.href && theme === "dark"
                            ? "#b5ebff"
                            : `/${textActive}` !== item.href && theme === "light"
                            ? "#B8B8C1"
                            : `/${textActive}` === item.href && theme === "light"
                            ? "#0693FF"
                            : "#92929e",
                      }}>
                      {item.title}
                    </p>
                  </NavigationMobileItem>
                </Link>
              );
            })}
          </NavigationMobile>
        </NavigationMobileMain>
      {/* </HeaderDashboardWrapper> */}
    </HeaderDashboardContainer>
  );
};

const earnMenu: any = [
  {
    id: 1,
    title: "Farm",
    href: "/farms",
    delay: "0.1s",
    icon: iconStaking,
    light: iconStaking_light,
  },
  {
    id: 1,
    title: "Pool",
    href: "/pools",
    delay: "0.2s",
    icon: iconStaking,
    light: iconStaking_light,
  },
  {
    id: 2,
    title: "Liquidity",
    href: "/liquidity",
    delay: "0.3s",
    icon: iconLiquidity,
    light: iconLiquidity_light,
  },
  /*{
    id: 3,
    title: "Stake",
    href: "/staking",
    delay: "0.4s",
    icon: iconStaking,
    light: iconStaking_light,
  },*/
];

const navDataMobile: any = [
  /*{
    id: 1,
    title: "Presale",
    href: "/presale",
    delay: "0.1s",
    icon: iconSwap,
    light: iconSwap_light,
  },*/
  {
    id: 2,
    title: "Trade",
    href: "/swap",
    delay: "0.1s",
    icon: iconSwap,
    light: iconSwap_light,
  },
  {
    id: 3,
    title: "Farm",
    href: "/farms",
    delay: "0.1s",
    icon: iconStaking,
    light: iconStaking_light,
  },
  {
    id: 5,
    title: "Staking",
    href: "/pools",
    delay: "0.2s",
    icon: iconStaking,
    light: iconStaking_light,
  },
  {
    id: 4,
    title: "Liquidity",
    href: "/liquidity",
    delay: "0.3s",
    icon: iconLiquidity,
    light: iconLiquidity_light,
  },
  /*{
    id: 6,
    title: "Stake",
    href: "/staking",
    delay: "0.4s",
    icon: iconStaking,
    light: iconStaking_light,
  },*/
  {
    id: 7,
    title: "Win",
    href: "/play",
    delay: "0.5s",
    icon: iconLauch,
    light: iconLauch_light,
  },
];


const socialAction = [
  {
    icon: "/static/icon-tele.png",
    href: "https://t.me/",
  },
  {
    icon: "/static/icon-x.png",
    href: "https://twitter.com/",
  },
  {
    icon: "/static/icon-dis.png",
    href: "https://discord.gg/",
  },
];

export default HeaderDashboard;
